// opening and closing variant details

const variantDetails = document.querySelectorAll(".variant-details");
const optionWrappers = document.querySelectorAll(
  ".variant-types .option-wrapper"
);
const dynamicHeight =
  window.innerHeight - 174 - 50 * (optionWrappers.length - 1);

// Dynamically set the height of .mobile-scroll on mobile, subtracting .custom-summary height
function setMobileScrollHeight() {
  const mobileThreshold = 1024; // 1024px or below is considered mobile (Tailwind lg breakpoint)
  const mobileScroll = document.querySelector(".mobile-scroll");
  const customSummary = document.querySelector(".custom-summary");
  if (mobileScroll) {
    if (window.innerWidth < mobileThreshold && customSummary) {
      const summaryRect = customSummary.getBoundingClientRect();
      // Make sure the dynamicHeight is positive and customSummary is visible
      let customSummaryHeight =
        summaryRect.height || customSummary.offsetHeight || 0;
      let scrollHeight = dynamicHeight - customSummaryHeight;
      // Ensure a minimum scrollHeight (never negative)
      scrollHeight = Math.max(0, scrollHeight);
      mobileScroll.style.maxHeight = scrollHeight + "px";
      mobileScroll.style.overflowY = "auto";
    } else {
      // Remove custom height on desktop or if summary is not found
      mobileScroll.style.maxHeight = "";
      mobileScroll.style.overflowY = "";
    }
  }
}

// Run on page load and when window resizes
window.addEventListener("DOMContentLoaded", setMobileScrollHeight);
window.addEventListener("resize", setMobileScrollHeight);

// In case dynamicHeight or custom-summary changes due to interactions, also expose as global for re-calling
window.setMobileScrollHeight = setMobileScrollHeight;

// --- Configurator subtotal (variant price x qty) ---
function formatMoneyCents(cents) {
  const format = window.SwymOverrideMoneyFormat || "${{amount}}";
  const amount = (cents / 100).toFixed(2);
  const amountNoDecimals = Math.round(cents / 100).toString();
  return format
    .replace("{{amount}}", amount)
    .replace("{{amount_no_decimals}}", amountNoDecimals);
}

function getConfiguratorQuantity() {
  const qtyInput = document.getElementById("simple-quantity");
  const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
  return Number.isFinite(qty) && qty > 0 ? qty : 1;
}

function updateConfiguratorSubtotalFromVariant(variant) {
  const subtotalEls = document.querySelectorAll("[data-configurator-subtotal]");
  if (!subtotalEls.length) return;
  if (!variant) return;

  const cents = Number(variant.price);
  if (!Number.isFinite(cents)) return;

  const qty = getConfiguratorQuantity();
  const subtotal = cents * qty;

  subtotalEls.forEach((el) => {
    el.textContent = formatMoneyCents(subtotal);
    // Hide the unit-price display in the same block so subtotal is authoritative
    const priceWrap = el.closest(".text-right");
    if (priceWrap) {
      const fromPrice = priceWrap.querySelector(".from-price");
      const mainPrice = priceWrap.querySelector(".main-price");
      if (fromPrice) fromPrice.style.display = "none";
      if (mainPrice) mainPrice.style.display = "none";
    }
  });
}

function updateConfiguratorSubtotal() {
  if (!userHasSelectedVariant) return;
  // Use the same selection logic as the configurator
  if (!window.productVariants || !window.productVariants.length) return;
  if (typeof getCustomSelectedOptions !== "function") return;
  if (typeof findVariantForConfiguratorPricing !== "function") return;
  const selected = getCustomSelectedOptions();
  const variant = findVariantForConfiguratorPricing(selected);
  updateConfiguratorSubtotalFromVariant(variant);
}

function toggleModalBg() {
  document.querySelector(".modal-bg").classList.toggle("active");
}

function toggleConfigurator() {
  document
    .querySelector(".custom-configurator-full")
    .classList.toggle("active");
}

const configuratorToggles = document.querySelectorAll(".config-toggle");
configuratorToggles.forEach((configuratorToggle) => {
  configuratorToggle.addEventListener("click", () => {
    toggleConfigurator();
    setTimeout(() => {
      toggleModalBg();
    }, 300);
  });
});

// Close configurator when clicking outside the content areas
document.addEventListener("DOMContentLoaded", function () {
  const configuratorForm = document.getElementById("custom-configurator-form");
  if (configuratorForm) {
    configuratorForm.addEventListener("click", function (event) {
      // Check if click is on the form itself or outside the content areas
      const outcomeArea = configuratorForm.querySelector(".custom-configurator-outcome");
      const holderArea = configuratorForm.querySelector(".custom-configurator-holder");
      
      // Check if the click target is inside either content area
      const isInsideOutcome = outcomeArea && outcomeArea.contains(event.target);
      const isInsideHolder = holderArea && holderArea.contains(event.target);
      
      // If click is NOT inside either content area, close the configurator
      if (!isInsideOutcome && !isInsideHolder) {
        // Only close if the configurator is currently open
        if (configuratorForm.classList.contains("active")) {
          toggleConfigurator();
          setTimeout(() => {
            toggleModalBg();
          }, 300);
        }
      }
    });
  }
});

variantDetails.forEach((variantDetail, index) => {
  if (variantDetail.classList.contains("open")) {
    gsap.to(variantDetail.querySelector(".details"), {
      height: dynamicHeight,
      duration: 0.5,
      ease: "power2.inOut",
    });
  }
  const summary = variantDetail.querySelector(".summary");
  const details = variantDetail.querySelector(".details");
  summary.addEventListener("click", () => {
    if (variantDetail.classList.contains("open")) {
      gsap.to(details, {
        height: 0,
        duration: 0.5,
        ease: "power2.inOut",
      });
      variantDetail.classList.toggle("open");
    } else {
      // Calculate the dynamic height based on the number of .option-wrapper elements inside .variant-types

      variantDetail.classList.remove("triggered");
      // Close all other variant details
      variantDetails.forEach((vd, i) => {
        if (vd !== variantDetail && vd.classList.contains("open")) {
          const otherDetails = vd.querySelector(".details");
          gsap.to(otherDetails, {
            height: 0,
            duration: 0.5,
            ease: "power2.inOut",
          });
          vd.classList.remove("open");
        }
      });
      // Open the clicked variant detail
      gsap.to(details, {
        height: dynamicHeight,
        duration: 0.5,
        ease: "power2.inOut",
      });
      variantDetail.classList.toggle("open");

      let matching = variantDetail.querySelector(".matching");
      if (matching) {
        // Find the previous variantDetail (if any)
        const prevVariantDetail = variantDetails[index - 1];
        if (prevVariantDetail) {
          // Find the checked input in the previous variantDetail
          const prevCheckedInput = prevVariantDetail.querySelector(
            '.details input[type="radio"]:checked, .details input[type="checkbox"]:checked'
          );
          console.log("prevCheckedInput", prevCheckedInput);
          if (prevCheckedInput) {
            // Get the img src from the previous selection
            let prevImgSrc = prevCheckedInput.dataset.img;
            // Find the img element inside the matching element
            let matchingImg = matching.querySelector("img");
            if (matchingImg && prevImgSrc) {
              matchingImg.src = prevImgSrc;
              matchingImg.classList.remove("opacity-0");
            }

            // Also update the data-img attribute for the matching input
            const matchingInput = matching.querySelector("input");
            if (matchingInput) {
              matchingInput.dataset.img = prevImgSrc;
            }
          }
        }
      }

      const nextVariantDetail = variantDetails[Number(index) + 1];
      // console.log("nextVariantDetail", nextVariantDetail)
      if (nextVariantDetail) {
        // Check if any checkbox or radio input inside .details is checked
        const checkedInput = nextVariantDetail.querySelector(
          '.details input[type="checkbox"]:checked, .details input[type="radio"]:checked'
        );
        if (checkedInput || nextVariantDetail.classList.contains("complete")) {
          nextVariantDetail.classList.add("triggered");
        } else {
          nextVariantDetail.classList.remove("triggered");
        }
      }
    }
  });
  const inputs = variantDetail.querySelectorAll("input");
  inputs.forEach((input) => {
    input.addEventListener("change", () => {
      delete input.dataset.autoSelected;
      // Mark that user has manually selected a variant
      userHasSelectedVariant = true;
      
      variantDetails.forEach((vd) => vd.classList.remove("triggered"));
      const nextVariantDetail = variantDetails[index + 1];
      if (nextVariantDetail) {
        nextVariantDetail.classList.add("triggered");
        // If this is the last variantDetail, add class 'complete'
        if (Number(index) + 1 === variantDetails.length - 1) {
          nextVariantDetail.classList.add("complete");
        }
      }
      let target = input.dataset.name;
      let targetImg = input.dataset.img;
      console.log(input)
      if (targetImg == "nil" || targetImg == "") {
        targetImg = null;
      }

      const selection = document.querySelectorAll(
        '.selection[data-name="' + target + '"]'
      );
      const summarySelectionText = document.querySelector(
        '.summary-selection[data-name="' + target + '"] .selection'
      );
      const summarySelectionImg = document.querySelector(
        '.summary-selection[data-name="' + target + '"] img'
      );

      selection.forEach((item) => {
        item.classList.remove("opacity-50");
        item.innerHTML = input.dataset.value;

        // Add active class to the parent configurator button
        const configuratorBtn = item.closest(".configurator-btn");
        if (configuratorBtn) {
          configuratorBtn.classList.add("active");
        }
      });

      if (summarySelectionText) {
        summarySelectionText.innerHTML = input.dataset.value;
      }

      // Handle matching upholstery - copy image from previous selection
      if (targetImg != null) {
        summarySelectionImg.src = targetImg;
        summarySelectionImg.classList.remove("opacity-0");
      } else if (
        input.dataset.value &&
        input.dataset.value.toLowerCase().includes("matching")
      ) {
        // For matching upholstery, try to get image from previous selection
        const prevVariantDetail = variantDetails[index - 1];
        if (prevVariantDetail) {
          const prevCheckedInput = prevVariantDetail.querySelector(
            '.details input[type="radio"]:checked, .details input[type="checkbox"]:checked'
          );
          if (prevCheckedInput && prevCheckedInput.dataset.img) {
            summarySelectionImg.src = prevCheckedInput.dataset.img;
            summarySelectionImg.classList.remove("opacity-0");
          } else {
            summarySelectionImg.classList.add("opacity-0");
          }
        } else {
          summarySelectionImg.classList.add("opacity-0");
        }
      } else if (summarySelectionImg !== null) {
        summarySelectionImg.classList.add("opacity-0");
      }

      // Update properties in both forms when selections change
      if (typeof updateFormProperties === "function") {
        updateFormProperties();
      }

      // Update any matching upholstery that might be affected by this change
      updateMatchingUpholstery();

      // Trigger variant change to update prices
      triggerVariantChangeDebounced();

      // Check if all configurator buttons are active and show form
      checkAndShowForm();
      notifyConfiguratorOptionChanged(getVariantDetailOptionIndex(variantDetail));
    });

    // Add change event listener to handle deselection properly
    input.addEventListener("change", (e) => {
      // If the input was unchecked (deselected), update the display
      if (
        !e.target.checked &&
        e.target.type === "radio"
      ) {
        const target = e.target.dataset.name;
        const selection = document.querySelectorAll(
          '.selection[data-name="' + target + '"]'
        );
        const summarySelectionText = document.querySelector(
          '.summary-selection[data-name="' + target + '"] .selection'
        );
        const summarySelectionImg = document.querySelector(
          '.summary-selection[data-name="' + target + '"] img'
        );

        selection.forEach((item) => {
          item.classList.add("opacity-50");
          item.innerHTML = "Make Selection";

          // Remove active class from the parent configurator button
          const configuratorBtn = item.closest(".configurator-btn");
          if (configuratorBtn) {
            configuratorBtn.classList.remove("active");
          }
        });

        if (summarySelectionText) {
          summarySelectionText.innerHTML = "Make Selection";
        }
        if (summarySelectionImg) {
          summarySelectionImg.classList.add("opacity-0");
        }

        // Update properties and prices
        if (typeof updateFormProperties === "function") {
          updateFormProperties();
        }
        triggerVariantChangeDebounced();
        checkAndShowForm();
        notifyConfiguratorOptionChanged(getVariantDetailOptionIndex(variantDetail));
      }
    });

    // Add click handler to allow deselecting by clicking the same option again
    if (input.type === "radio") {
      // Store the checked state before the click
      let wasCheckedBeforeClick = false;
      
      input.addEventListener("mousedown", (e) => {
        if (input.closest(".not-active")) {
          e.preventDefault();
          return;
        }
        // Capture the state before the click happens
        wasCheckedBeforeClick = input.checked;
      });
      
      input.addEventListener("click", (e) => {
        if (input.closest(".not-active")) {
          e.preventDefault();
          return;
        }
        // If it was already checked before the click, uncheck it
        if (wasCheckedBeforeClick) {
          e.preventDefault();
          e.stopPropagation();
          input.checked = false;
          
          // Trigger change event to update the UI
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      
      // Also handle label clicks for the same input
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (label) {
        let labelWasChecked = false;
        
        label.addEventListener("mousedown", (e) => {
          // Capture the state before the label click
          labelWasChecked = input.checked;
        });
        
        label.addEventListener("click", (e) => {
          // If the input was already checked before the label click, uncheck it
          if (labelWasChecked) {
            e.preventDefault();
            e.stopPropagation();
            input.checked = false;
            
            // Trigger change event to update the UI
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    }
  });
});

const editSelection = document.querySelectorAll(".edit-selection");
editSelection.forEach((editSelection) => {
  editSelection.addEventListener("click", () => {
    const index = editSelection.dataset.index;

    const nextVariantDetail = variantDetails[Number(index) + 1];
    if (nextVariantDetail) {
      // Check if any checkbox or radio input inside .details is checked
      const checkedInput = nextVariantDetail.querySelector(
        '.details input[type="checkbox"]:checked, .details input[type="radio"]:checked'
      );
      if (checkedInput) {
        nextVariantDetail.classList.add("triggered");
      } else {
        nextVariantDetail.classList.remove("triggered");
      }
    }

    variantDetails[index].classList.toggle("open");
    const variantDetail = variantDetails[index].querySelector(".details");
    gsap.to(variantDetail, {
      height: dynamicHeight,
      duration: 0.5,
      ease: "power2.inOut",
    });
    document.querySelector("#variant-details-summary").classList.remove("open");
    gsap.to(document.querySelector("#variant-details-summary .details"), {
      height: 0,
      duration: 0.5,
      ease: "power2.inOut",
    });
    updateConfiguratorOptionAvailability();
  });
});

const configuratorBtns = document.querySelectorAll(".configurator-btn");
configuratorBtns.forEach((configuratorBtn) => {
  configuratorBtn.addEventListener("click", () => {
    const option = configuratorBtn.dataset.option;
    const index = configuratorBtn.dataset.index;

    if (!document.querySelector(".custom-configurator-full.active")) {
      toggleModalBg();
      toggleConfigurator();
    }
    // document.querySelectorAll('.variant-details');
    variantDetails.forEach((variantDetail) => {
      variantDetail.classList.remove("open");
    });
    document
      .querySelector('.variant-details[data-option="' + option + '"]')
      .classList.add("open");
    gsap.to(".variant-details .details", {
      height: 0,
      duration: 0.5,
      ease: "power2.inOut",
    });
    gsap.to('.variant-details[data-option="' + option + '"] .details', {
      height: dynamicHeight,
      duration: 0.5,
      ease: "power2.inOut",
    });
    updateConfiguratorOptionAvailability();
  });
});

function toggleSwatchSet(e) {
  if (e && e.closest && e.closest(".not-active")) return;
  e.classList.toggle("open");
  const swatchSet = e.parentNode.querySelector(".swatch-set");
  const swatchSetDescription =
    e.parentNode.parentNode.querySelector(".swatch-data");
  const dropName = e.parentNode.querySelector(".drop-name");
  // dropName.classList.toggle('h-4');
  // console.log(e.parentNode)
  if (e.classList.contains("open")) {
    gsap.to(swatchSet, {
      height: "auto",
      duration: 0.5,
      ease: "power2.inOut",
    });
    gsap.to(swatchSetDescription, {
      height: 0,
      opacity: 0,
      duration: 0.5,
      ease: "power2.inOut",
    });
    gsap.to(dropName, {
      height: "auto",
      duration: 0.5,
      ease: "power2.inOut",
    });
  } else {
    gsap.to(swatchSet, {
      height: 0,
      duration: 0.5,
      ease: "power2.inOut",
    });
    gsap.to(swatchSetDescription, {
      height: "auto",
      opacity: 1,
      duration: 0.5,
      ease: "power2.inOut",
    });
    gsap.to(dropName, {
      height: 28,
      duration: 0.5,
      ease: "power2.inOut",
    });
  }
}

// adding swatch main img
const swatchGroup = document.querySelectorAll(".swatch-group");
swatchGroup.forEach((swatchGroup) => {
  const items = swatchGroup.querySelectorAll(".swatch-item");
  const img = swatchGroup.querySelector(".swatch-main-img");
  for (let i = 0; i < items.length; i++) {
    img.src = items[0].dataset.imgSrc;
  }
  // const img = swatchGroup.querySelector('img');
  // img.src = swatchGroup.dataset.src;
});

//Select Swatch Item
function customSwatchSelect(event, domEvent) {
  if (event && event.classList && event.classList.contains("not-active")) {
    if (domEvent && domEvent.preventDefault) domEvent.preventDefault();
    return;
  }
  const parent = event.parentElement.parentElement.parentElement;
  const fullswatchcontainer = parent.parentElement;
  // Use checkbox inside the clicked label when present (No Upholstery / Further Options) so we don't get the first checkbox in the group
  const checkInsideLabel = event.querySelector && event.querySelector(".basic-radio");
  const check = checkInsideLabel || parent.querySelector(".basic-radio");
  let selectedItemName = event.getAttribute("data-swatch-item");
  let parentSet = event.getAttribute("data-parent");
  let selecedItemImg = event.getAttribute("data-img-src");

  console.log(fullswatchcontainer);
  const openElement = parent.querySelector(".open");
  if (openElement) {
    toggleSwatchSet(openElement);
  }
  const grandparent = parent.parentElement.parentElement;

  // Check if this swatch is already selected
  const isAlreadySelected = event.classList.contains("bg-gray-100");

  let setAllSwatches = Array.from(grandparent.querySelectorAll(".swatch-item"));
  setAllSwatches.forEach((swatch) => {
    swatch.classList.remove("bg-gray-100");
  });

  if (!isAlreadySelected) {
    // Check if this is "No Upholstery" option
    const isNoUpholstery = check && (check.value === "No Upholstery" || check.value === "Further Options" || !selectedItemName);

    // Prevent label from toggling the checkbox after we set it (would clear selection)
    if (isNoUpholstery && domEvent && domEvent.preventDefault) {
      domEvent.preventDefault();
    }

    if (check) delete check.dataset.autoSelected;
    
    // Mark that user has manually selected a variant
    userHasSelectedVariant = true;
    
    // Select the swatch
    event.classList.add("bg-gray-100");

    let settextholders = Array.from(
      grandparent.querySelectorAll(".selected-text-holder")
    );
    settextholders.forEach((item) => {
      gsap.to(item, {
        height: 0,
        opacity: 0,
        duration: 0.5,
        ease: "power2.inOut",
      });
    });

    // Handle selected-text display (only if element exists, not for "No Upholstery")
    const selectedText = fullswatchcontainer.querySelector(".selected-text");
    const selectedTextHolder = fullswatchcontainer.querySelector(".selected-text-holder");
    if (selectedText && !isNoUpholstery) {
      selectedText.innerHTML = selectedItemName;
      if (selectedTextHolder) {
        gsap.to(selectedTextHolder, {
          height: "auto",
          opacity: 1,
          duration: 0.5,
          ease: "power2.inOut",
        });
      }
    }
    // Only show swatch-details-container for regular swatches, not "No Upholstery"
    if (!isNoUpholstery) {
      var sdc = document.querySelector(".swatch-details-container");
      if (sdc != null) {
        var detailsTimeline = gsap.timeline().reversed(true);
        detailsTimeline
          .to(".swatch-details-container", {
            height: dynamicHeight,
            duration: 0.5,
            pointerEvents: "all",
            ease: "power2,inOut",
          })
          .to(".swatch-details-container", { opacity: 1, duration: 0.3 }, 0.4);
        detailsTimeline.play();
      }
    }

    const img = parent.querySelector(".swatch-main-img");
    let imgSrcToUse = selecedItemImg;
    const variantDetailsContainer = check.closest('.variant-details');
    if (check.value === "No Upholstery" && variantDetailsContainer) {
      const variantDetails = document.querySelectorAll(".variant-details:not(#variant-details-summary)");
      const currentIndex = Array.from(variantDetails).indexOf(variantDetailsContainer);
      const prevVariantDetail = currentIndex > 0 ? variantDetails[currentIndex - 1] : null;
      if (prevVariantDetail) {
        const prevCheckedInput = prevVariantDetail.querySelector(
          '.details input[type="radio"]:checked, .details input[type="checkbox"]:checked'
        );
        const prevImg = prevCheckedInput && (prevCheckedInput.dataset.img || prevCheckedInput.getAttribute("data-img"));
        if (prevImg && prevImg !== "nil" && prevImg !== "") {
          imgSrcToUse = prevImg;
        }
      }
    }
    if (img && imgSrcToUse && imgSrcToUse !== "nil" && imgSrcToUse !== "" && check.value !== "No Upholstery") {
      img.src = imgSrcToUse;
      check.setAttribute("data-img", imgSrcToUse);
    } else if (check) {
      check.setAttribute("data-img", (check.value === "No Upholstery" ? imgSrcToUse : "") || "");
    }
    // No Upholstery: set the image on the card's own img (inside the label) so it displays the previous option's image
    if (check.value === "No Upholstery" && imgSrcToUse && imgSrcToUse !== "nil" && imgSrcToUse !== "") {
      const noUpholsteryImg = event.querySelector ? event.querySelector("img") : null;
      if (noUpholsteryImg) {
        noUpholsteryImg.src = imgSrcToUse;
      }
    }

    if (variantDetailsContainer) {
      const allInputsInGroup = variantDetailsContainer.querySelectorAll(
        'input[type="radio"], input[type="checkbox"]'
      );
      allInputsInGroup.forEach((input) => {
        if (input !== check && input.name === check.name) {
          input.checked = false;
        }
      });
    }
    
    // Set data-value: for "No Upholstery" use just the value, otherwise use "parentSet in selectedItemName"
    if (isNoUpholstery) {
      check.setAttribute("data-value", check.value);
    } else {
      check.setAttribute("data-value", `${parentSet} in ${selectedItemName}`);
    }
    check.setAttribute("checked", "checked");
    check.checked = true;
    
    console.log('🔘 Swatch selected - Checkbox:', {
      value: check.value,
      name: check.name,
      checked: check.checked,
      hasCheckedAttr: check.hasAttribute('checked'),
      id: check.id,
      parentSet: parentSet,
      selectedItem: selectedItemName,
      isNoUpholstery: isNoUpholstery,
      variantDetails: variantDetailsContainer ? variantDetailsContainer.dataset.option : 'not found'
    });
    
    setTimeout(() => {
      console.log('🔍 Checkbox verification after 10ms:', {
        checked: check.checked,
        hasCheckedAttr: check.hasAttribute('checked'),
        value: check.value,
        inVariantDetails: check.closest('.variant-details') ? 'yes' : 'no'
      });
      
      // If it got unchecked, re-check it
      if (!check.checked) {
        console.log('⚠️ Checkbox was unchecked! Re-checking it...');
        check.checked = true;
        check.setAttribute("checked", "checked");
      }
    }, 10);
    
  
    var materialValue = isNoUpholstery ? "" : `${parentSet} in ${selectedItemName}`;
    const materialInput = document.querySelector("input#line-material");
    if (materialInput) {
      materialInput.value = materialValue;
    }
    var simpleMaterialInput = document.querySelector(
      "input#simple-line-material"
    );
    if (simpleMaterialInput) {
      simpleMaterialInput.value = materialValue;
    }

    const target = check.dataset.name;
    const selection = document.querySelectorAll(
      '.selection[data-name="' + target + '"]'
    );
    const summarySelectionText = document.querySelector(
      '.summary-selection[data-name="' + target + '"] .selection'
    );
    const summarySelectionImg = document.querySelector(
      '.summary-selection[data-name="' + target + '"] img'
    );

    // Use the material value for display (e.g., "Leather in Black" or "No Upholstery")
    const displayValue = isNoUpholstery ? check.value : (check.dataset.value || materialValue);

    selection.forEach((item) => {
      item.classList.remove("opacity-50");
      item.innerHTML = displayValue;

      // Add active class to the parent configurator button
      const configuratorBtn = item.closest(".configurator-btn");
      if (configuratorBtn) {
        configuratorBtn.classList.add("active");
      }
    });

    if (summarySelectionText) {
      summarySelectionText.innerHTML = displayValue;
    }

    // Handle image display for summary (No Upholstery only uses previous variant image; Further Options stays blank)
    const summaryImgSrc = check.value === "No Upholstery" ? imgSrcToUse : selecedItemImg;
    if (summaryImgSrc && summaryImgSrc !== "nil" && summaryImgSrc !== "") {
      if (summarySelectionImg) {
        summarySelectionImg.src = summaryImgSrc;
        summarySelectionImg.classList.remove("opacity-0");
      }
    } else if (summarySelectionImg) {
      summarySelectionImg.classList.add("opacity-0");
    }

    // Update properties in both forms when selections change
    if (typeof updateFormProperties === "function") {
      updateFormProperties();
    }

    // Update any matching upholstery that might be affected by this change
    updateMatchingUpholstery();

    // Trigger variant change to update prices and URL
    // Use debounced version to prevent multiple rapid calls
    triggerVariantChangeDebounced();

    // Check if all configurator buttons are active and show form
    checkAndShowForm();
    notifyConfiguratorOptionChanged(
      getVariantDetailOptionIndex(
        event.closest ? event.closest(".variant-details") : null
      )
    );
  } else {
    // Deselect the swatch
    if (check && check.value === "No Upholstery") {
      if (domEvent) domEvent.preventDefault();
      check.removeAttribute("checked");
    }
    let settextholders = Array.from(
      grandparent.querySelectorAll(".selected-text-holder")
    );
    settextholders.forEach((item) => {
      gsap.to(item, {
        height: 0,
        opacity: 0,
        duration: 0.5,
        ease: "power2.inOut",
      });
    });

    // Clear the selection
    check.setAttribute("data-value", "");
    check.setAttribute("data-img", "");
    check.checked = false;
    document.querySelector("input#line-material").value = "";
    var simpleMaterialInput = document.querySelector(
      "input#simple-line-material"
    );
    if (simpleMaterialInput) {
      simpleMaterialInput.value = "";
    }

    // Clear the selection display
    const target = check.dataset.name;
    const selection = document.querySelectorAll(
      '.selection[data-name="' + target + '"]'
    );
    const summarySelectionText = document.querySelector(
      '.summary-selection[data-name="' + target + '"] .selection'
    );
    const summarySelectionImg = document.querySelector(
      '.summary-selection[data-name="' + target + '"] img'
    );

    selection.forEach((item) => {
      item.classList.add("opacity-50");
      item.innerHTML = "Make Selection";

      // Remove active class from the parent configurator button
      const configuratorBtn = item.closest(".configurator-btn");
      if (configuratorBtn) {
        configuratorBtn.classList.remove("active");
      }
    });

    if (summarySelectionText) {
      summarySelectionText.innerHTML = "Make Selection";
    }
    if (summarySelectionImg) {
      summarySelectionImg.classList.add("opacity-0");
    }

    // Update properties and prices
    if (typeof updateFormProperties === "function") {
      updateFormProperties();
    }
    triggerVariantChangeDebounced();
    checkAndShowForm();
    notifyConfiguratorOptionChanged(
      getVariantDetailOptionIndex(
        event && event.closest ? event.closest(".variant-details") : null
      )
    );
  }
}

// Handle size option line drawings - this should work with the main input system
// The size options are regular radio inputs with basic-radio class, so they're handled by the main input system
// This function just handles the line drawing display
function updateSizeLineDrawing() {
  const checkedSizeInput = document.querySelector(
    'input[name*="size"]:checked, input[name*="Size"]:checked'
  );
  const img = document.querySelector(".line-drawing-wrapper img");
  const dimensions = document.querySelector(
    ".line-drawing-wrapper .dimensions"
  );
  if (checkedSizeInput && img) {
    const imgSrc = checkedSizeInput.dataset.img;
    if (imgSrc) {
      img.src = imgSrc;
      img.classList.remove("opacity-0");
    } else {
      img.classList.add("opacity-0");
    }
  } else if (img) {
    // No size selected, hide the line drawing
    img.classList.add("opacity-0");
  }

  if (dimensions && checkedSizeInput && checkedSizeInput.dataset) {
    dimensions.innerHTML = checkedSizeInput.dataset.dimensions || "";
  } else if (dimensions) {
    dimensions.innerHTML = "";
  }
}

// Listen for size option changes and update line drawings
document.addEventListener("change", function (e) {
  if (
    e.target.classList.contains("basic-radio") &&
    e.target.dataset.name &&
    e.target.dataset.name.toLowerCase().includes("size")
  ) {
    updateSizeLineDrawing();
  }
});

// Handle deselection when clicking on selected-text-holder .basic-radio
document.addEventListener("DOMContentLoaded", function () {
  // Use event delegation to handle clicks on the checked radio icon in selected-text-holder
  document.addEventListener("click", function (e) {
    // Check if clicking on the .basic-radio.checked inside .selected-text-holder
    const clickedRadio = e.target.closest(".selected-text-holder .basic-radio.checked");
    if (!clickedRadio) return;
    
    // Find the swatch group container
    const swatchGroup = clickedRadio.closest(".swatch-group");
    if (!swatchGroup) return;
    
    // Find the actual checkbox/radio input (not the visual .basic-radio.checked div)
    const check = swatchGroup.querySelector("input.basic-radio");
    if (!check) return;
    
    // Find the parent swatch container structure
    const parent = swatchGroup.parentElement;
    const fullswatchcontainer = parent?.parentElement;
    const grandparent = parent?.parentElement?.parentElement;
    
    if (!grandparent || !fullswatchcontainer) return;
    
    // Find the currently selected swatch item (the one with bg-gray-100)
    const selectedSwatchItem = Array.from(grandparent.querySelectorAll(".swatch-item")).find(
      (swatch) => swatch.classList.contains("bg-gray-100")
    );
    
    // If there's a selected swatch item, trigger deselection by simulating a click on it
    // This will use the existing deselection logic in customSwatchSelect
    if (selectedSwatchItem) {
      // The swatch item is already selected, so clicking it will deselect it
      // We need to manually trigger the deselection logic
      const isAlreadySelected = selectedSwatchItem.classList.contains("bg-gray-100");
      
      if (isAlreadySelected) {
        // Manually trigger the deselection part of customSwatchSelect
        let setAllSwatches = Array.from(grandparent.querySelectorAll(".swatch-item"));
        setAllSwatches.forEach((swatch) => {
          swatch.classList.remove("bg-gray-100");
        });
        
        let settextholders = Array.from(grandparent.querySelectorAll(".selected-text-holder"));
        settextholders.forEach((item) => {
          gsap.to(item, {
            height: 0,
            opacity: 0,
            duration: 0.5,
            ease: "power2.inOut",
          });
        });
        
        // Clear the selection
        check.removeAttribute("checked");
        check.checked = false;
        check.setAttribute("data-value", "");
        check.setAttribute("data-img", "");
        
        // Clear material input
        const materialInput = document.querySelector("input#line-material");
        if (materialInput) {
          materialInput.value = "";
        }
        const simpleMaterialInput = document.querySelector("input#simple-line-material");
        if (simpleMaterialInput) {
          simpleMaterialInput.value = "";
        }
        
        // Clear the selection display
        const target = check.dataset.name;
        const selection = document.querySelectorAll('.selection[data-name="' + target + '"]');
        const summarySelectionText = document.querySelector(
          '.summary-selection[data-name="' + target + '"] .selection'
        );
        const summarySelectionImg = document.querySelector(
          '.summary-selection[data-name="' + target + '"] img'
        );
        
        selection.forEach((item) => {
          item.classList.add("opacity-50");
          item.innerHTML = "Make Selection";
          
          // Remove active class from the parent configurator button
          const configuratorBtn = item.closest(".configurator-btn");
          if (configuratorBtn) {
            configuratorBtn.classList.remove("active");
          }
        });
        
        if (summarySelectionText) {
          summarySelectionText.innerHTML = "Make Selection";
        }
        if (summarySelectionImg) {
          summarySelectionImg.classList.add("opacity-0");
        }
        
        // Update properties and prices
        if (typeof updateFormProperties === "function") {
          updateFormProperties();
        }
        triggerVariantChangeDebounced();
        checkAndShowForm();
        notifyConfiguratorOptionChanged(
          getVariantDetailOptionIndex(check.closest(".variant-details"))
        );
      }
    }
  });
});

// Initialize size line drawing on page load
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(updateSizeLineDrawing, 200);
});

function escapePdfHtml(str) {
  if (!str) return "";
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function parsePdfMoney(text) {
  if (!text) return null;
  const num = parseFloat(String(text).replace(/[^0-9.]/g, ""));
  return Number.isFinite(num) ? num : null;
}

function formatPdfCurrency(amount, currency) {
  return amount.toLocaleString(undefined, {
    style: "currency",
    currencyDisplay: "symbol",
    currency: currency || "NZD",
    minimumFractionDigits: 0,
  });
}

function getConfiguratorPdfVariantInfo() {
  const selected =
    typeof getCustomSelectedOptions === "function"
      ? getCustomSelectedOptions()
      : [];
  const variant =
    typeof findVariantForConfiguratorPricing === "function"
      ? findVariantForConfiguratorPricing(selected)
      : null;
  return { selected, variant };
}

function getConfiguratorPdfMainImage(variant) {
  const meta = window.configuratorPdfMeta || {};
  if (meta.featuredImage) return meta.featuredImage;
  if (variant && variant.featured_image) return variant.featured_image;
  const galleryImg = document.querySelector(
    ".product-images img[src], .product-slider img[src]"
  );
  if (galleryImg && galleryImg.src) return galleryImg.src;
  return "";
}

function collectConfiguratorPdfSelectionsFromSummary() {
  const selections = [];

  document.querySelectorAll(".summary-selection").forEach(function (el) {
    const optionName = (
      el.querySelector(".selection-option")?.textContent ||
      el.dataset.name ||
      ""
    ).trim();
    const value = (el.querySelector(".selection")?.textContent || "").trim();
    const img = el.querySelector("img");
    let imgSrc = "";

    if (
      img &&
      img.src &&
      !img.classList.contains("opacity-0") &&
      !img.src.endsWith("/")
    ) {
      imgSrc = img.src;
    }

    if (value && value !== "Make Selection") {
      selections.push({
        optionName,
        value: value.replace(/\s*--\s*$/, "").trim(),
        imgSrc,
      });
    }
  });

  return selections;
}

function collectConfiguratorPdfSelectionsFromInputs() {
  const selections = [];
  const optionNames = window.configuratorOptionNames || [];

  optionNames.forEach(function (optionName) {
    const input = document.querySelector(
      '#custom-configurator-form .basic-radio[data-name="' +
        optionName +
        '"]:checked'
    );
    if (!input || !input.dataset.value) return;

    let imgSrc = input.dataset.img || "";
    if (imgSrc === "nil") imgSrc = "";

    selections.push({
      optionName: optionName,
      value: input.dataset.value.replace(/\s*--\s*$/, "").trim(),
      imgSrc: imgSrc,
    });
  });

  return selections;
}

function getConfiguratorPdfSelections() {
  const fromSummary = collectConfiguratorPdfSelectionsFromSummary();
  if (fromSummary.length) return fromSummary;
  return collectConfiguratorPdfSelectionsFromInputs();
}

function normalizePdfLeadTime(text) {
  if (!text) return "";
  return String(text)
    .replace(/^estimated\s+lead\s+time\s*:?\s*/i, "")
    .trim();
}

function getConfiguratorPdfLeadTimeValue() {
  const meta = window.configuratorPdfMeta || {};
  const leadTimeEl =
    document.querySelector(".custom-summary .the-lead-time") ||
    document.querySelector(".custom-configurator-outcome .the-lead-time") ||
    document.querySelector(".custom-configurator-outcome .fixed-lead-time") ||
    document.querySelector(".custom-summary .fixed-lead-time");

  if (leadTimeEl) {
    const fromText = normalizePdfLeadTime(leadTimeEl.textContent.trim());
    if (fromText) return fromText;
    if (leadTimeEl.dataset.og) {
      return normalizePdfLeadTime(leadTimeEl.dataset.og);
    }
  }

  return normalizePdfLeadTime(meta.leadTime || "");
}

function getConfiguratorPdfVariantTitleHtml(selections, variant) {
  const optionLines = selections.map(function (sel) {
    return escapePdfHtml(sel.value);
  });

  if (optionLines.length) {
    return optionLines.join("<br/>");
  }

  if (variant && variant.title && variant.title !== "Default Title") {
    return escapePdfHtml(variant.title);
  }

  return "";
}

function buildConfiguratorPdfLeadTimeHtml(leadTimeValue) {
  if (!leadTimeValue) return "";

  return `
    <div style="font-size:12px;line-height:1.5;min-width:5.5rem;white-space:normal;word-break:normal;">
      <div style="display:block;margin-bottom:0.25rem;">Estimated lead time</div>
      <div style="display:block;">${escapePdfHtml(leadTimeValue)}</div>
    </div>
  `;
}

function buildConfiguratorPdfHtml() {
  const meta = window.configuratorPdfMeta || {};
  const { variant } = getConfiguratorPdfVariantInfo();
  const qty = getConfiguratorQuantity();
  const mainImageUrl = getConfiguratorPdfMainImage(variant);
  const selections = getConfiguratorPdfSelections();
  const variantTitleHtml = getConfiguratorPdfVariantTitleHtml(selections, variant);
  const prices = getConfiguratorPdfPrices(variant, qty);
  const leadTimeValue = getConfiguratorPdfLeadTimeValue();

  const productTitle = meta.displayTitle || meta.title || "";
  const productUrl =
    variant && variant.id ? meta.url + "?variant=" + variant.id : meta.url;

  const itemHtml = `
    <div class="col-span-full text-lg py-4 lg:border-b lg:border-solid lg:border-gray-200">
      ${escapePdfHtml(productTitle)}
    </div>
    <div class="col-span-1 w-full text-base py-4 lg:border-b lg:border-solid lg:border-gray-200" style="display:grid;grid-template-columns:repeat(13,minmax(0,1fr));column-gap:1rem;align-items:start;">
      <a class="lg:col-start-1 lg:col-end-3" style="grid-column:1 / span 2;" href="${escapePdfHtml(productUrl)}">
        <div class="w-full relative card-square lg:pb-0">
          ${
            mainImageUrl
              ? `<img class="absolute inset-0 w-full h-full lg:relative lg:h-auto bg-gray-100" src="${escapePdfHtml(mainImageUrl)}"/>`
              : ""
          }
        </div>
      </a>
      <div style="grid-column:4 / span 3;">
        <h3 class="mt-2">
          <a href="${escapePdfHtml(productUrl)}">
            ${escapePdfHtml(productTitle)}
            ${variantTitleHtml ? "<br/>" + variantTitleHtml : ""}
          </a>
        </h3>
        <div class="mt-4 text-xs">
          Quantity: <span>${qty}</span>
        </div>
      </div>
      <div class="text-xs" style="grid-column:8 / span 3;white-space:normal;">
        ${
          prices.enquireOnly
            ? "<div>Price on enquiry</div>"
            : `<div>${prices.hasTrade ? "Retail: " : ""}<span>${prices.priceFormatted}</span>${prices.hasTrade ? '<span class="text-xxs"> RRP</span>' : ""}</div>
          ${
            prices.tradePriceFormatted
              ? `<div>Trade: <span>${prices.tradePriceFormatted}</span><span class="text-xxs"> Trade incl GST</span></div>`
              : ""
          }`
        }
      </div>
      <div style="grid-column:12 / span 2;">
        ${buildConfiguratorPdfLeadTimeHtml(leadTimeValue)}
      </div>
    </div>
  `;

  return { itemHtml, prices, listTitle: productTitle };
}

function getConfiguratorPdfPrices(variant, qty) {
  const meta = window.configuratorPdfMeta || {};
  const currency = meta.currency || "NZD";

  if (meta.enquireOnly) {
    return {
      enquireOnly: true,
      priceFormatted: "",
      tradePriceFormatted: null,
      hasTrade: false,
    };
  }

  const priceContainer =
    document.querySelector(
      '.custom-configurator-outcome [data-price-container="true"]'
    ) ||
    document.querySelector('.custom-summary [data-price-container="true"]') ||
    document.querySelector('[data-price-container="true"]');

  let tradePriceFormatted = null;
  let hasTrade = false;
  let unitRrp = variant ? Number(variant.price) / 100 : null;

  if (priceContainer) {
    const tradeEl = priceContainer.querySelector(".tradeprice");
    if (tradeEl) {
      const tradeUnit = parsePdfMoney(tradeEl.textContent);
      if (tradeUnit != null) {
        hasTrade = true;
        tradePriceFormatted = formatPdfCurrency(tradeUnit * qty, currency);
      }
    }

    if (unitRrp == null) {
      const saleEl = priceContainer.querySelector(
        ".price-item--sale:not(.tradeprice)"
      );
      const regularEl = priceContainer.querySelector(
        ".price-item--regular, .price-item--sale"
      );
      const parsed = parsePdfMoney((saleEl || regularEl)?.textContent);
      if (parsed != null) unitRrp = parsed;
    }
  }

  const totalRrp = unitRrp != null ? unitRrp * qty : 0;
  const priceFormatted = formatPdfCurrency(totalRrp, currency);

  return {
    enquireOnly: false,
    priceFormatted,
    tradePriceFormatted,
    hasTrade,
  };
}

function downloadPDF() {
  const element = document.getElementById("SJD_configurator_pdf");
  if (!element || typeof html2pdf !== "function") return;

  const contentEl = document.getElementById("SJD_configurator_pdf_content");
  const totalsSection = document.getElementById("configurator_pdf_totals");
  const totalEl = document.querySelector(
    "#configurator_pdf_totals [data-pdf-total]"
  );
  const tradeTotalEl = document.querySelector(
    "#configurator_pdf_totals [data-pdf-trade-total]"
  );

  const built = buildConfiguratorPdfHtml();
  if (contentEl) contentEl.innerHTML = built.itemHtml;
  if (totalsSection) totalsSection.classList.remove("hidden");

  if (totalEl) {
    if (!built.prices.enquireOnly && built.prices.priceFormatted) {
      totalEl.innerHTML =
        built.prices.priceFormatted + '<span class="text-xxs">RRP</span>';
    } else {
      totalEl.innerHTML = "";
    }
  }

  if (tradeTotalEl) {
    if (built.prices.tradePriceFormatted) {
      tradeTotalEl.classList.remove("hidden");
      tradeTotalEl.innerHTML =
        built.prices.tradePriceFormatted +
        '<span class="text-xxs">Trade incl GST</span>';
    } else {
      tradeTotalEl.classList.add("hidden");
      tradeTotalEl.innerHTML = "";
    }
  }

  const filename =
    (built.listTitle || "my-selection").replace(/[^\w\s-]/g, "").trim() +
    ".pdf";

  html2pdf(element, {
    margin: 0.2,
    pagebreak: { mode: "avoid-all" },
    filename: filename,
    image: { type: "jpeg", quality: 0.9 },
    html2canvas: { scale: 3, useCORS: true },
    jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
  });
}

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener(
    "click",
    function (e) {
      if (
        e.target.closest(
          "#custom-configurator-form .variant-types .not-active"
        )
      ) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  setTimeout(function () {
    updateConfiguratorOptionAvailability();
  }, 100);

  // Keep subtotal in sync with qty changes
  const qtyInput = document.getElementById("simple-quantity");
  if (qtyInput) {
    qtyInput.addEventListener("input", updateConfiguratorSubtotal);
    qtyInput.addEventListener("change", updateConfiguratorSubtotal);
  }

  const modalBg = document.querySelector(".modal-bg");
  if (modalBg) {
    modalBg.addEventListener("click", function () {
      // Close all modals by removing 'active' or 'open' classes
      // Common modal selectors
      const modals = document.querySelectorAll(
        ".modal, .modal-bg, .custom-configurator-full, .modal.active, .custom-configurator-full.active"
      );
      modals.forEach((modal) => {
        modal.classList.remove("active");
        modal.classList.remove("open");
      });

      [
        "#downloads-modal",
        "#modal-sustainability",
        "#order-process",
        "#returns-modal",
        "#designer-modal",
      ].forEach((id) => {
        const el = document.querySelector(id);
        if (el) {
          if (!el.classList.contains("-translate-x-full")) {
            el.classList.add("-translate-x-full");
          }
        }
      });
      ["#enquiry-modal"].forEach((id) => {
        const el = document.querySelector(id);
        if (el) {
          if (!el.classList.contains("translate-x-full")) {
            el.classList.add("translate-x-full");
          }
        }
      });

      // Also close the custom configurator if open
      const configurator = document.querySelector(".custom-configurator-full");
      if (configurator) {
        configurator.classList.remove("active");
      }
    });
  }
});

// Keep subtotal in sync with variant changes
document.addEventListener("variant:change", function (e) {
  if (!userHasSelectedVariant) return;
  updateConfiguratorSubtotalFromVariant(e.detail && e.detail.variant);
});

// Function to update matching upholstery when previous selections change
function updateMatchingUpholstery() {
  const variantDetails = document.querySelectorAll(".variant-details:not(#variant-details-summary)");

  variantDetails.forEach((variantDetail, index) => {
    // Find any matching elements in this variant detail
    const matchingElements = variantDetail.querySelectorAll(".matching");

    matchingElements.forEach((matching) => {
      // Find the previous variantDetail (if any)
      const prevVariantDetail = variantDetails[index - 1];
      if (prevVariantDetail) {
        // Find the checked input in the previous variantDetail
        const prevCheckedInput = prevVariantDetail.querySelector(
          '.details input[type="radio"]:checked, .details input[type="checkbox"]:checked'
        );
        if (prevCheckedInput) {
          // Get the img src from the previous selection
          let prevImgSrc = prevCheckedInput.dataset.img || prevCheckedInput.getAttribute("data-img");

          // Update the matching image in the configurator
          let matchingImg = matching.querySelector("img");
          if (matchingImg && prevImgSrc) {
            matchingImg.src = prevImgSrc;
            matchingImg.classList.remove("opacity-0");
          }

          // Update the data-img attribute for the matching input
          const matchingInput = matching.querySelector("input");
          if (matchingInput) {
            matchingInput.dataset.img = prevImgSrc;
          }

          // If this matching option is currently selected, update the summary image too
          if (matchingInput && matchingInput.checked) {
            const target = matchingInput.dataset.name;
            const summarySelectionImg = document.querySelector(
              '.summary-selection[data-name="' + target + '"] img'
            );
            if (summarySelectionImg && prevImgSrc) {
              summarySelectionImg.src = prevImgSrc;
              summarySelectionImg.classList.remove("opacity-0");
            }
          }
        }
      }
    });

    // No Upholstery: when previous option is selected, always update the No Upholstery card's image (so it populates as soon as user selects previous item)
    const noUpholsteryInput = variantDetail.querySelector(
      '.details input[type="checkbox"][value="No Upholstery"]'
    );
    if (noUpholsteryInput && index > 0) {
      const prevVariantDetail = variantDetails[index - 1];
      const prevCheckedInput = prevVariantDetail.querySelector(
        '.details input[type="radio"]:checked, .details input[type="checkbox"]:checked'
      );
      const prevImgSrc = prevCheckedInput && (prevCheckedInput.dataset.img || prevCheckedInput.getAttribute("data-img"));
      if (prevImgSrc && prevImgSrc !== "nil" && prevImgSrc !== "") {
        noUpholsteryInput.setAttribute("data-img", prevImgSrc);
        const noUpholsteryLabel = noUpholsteryInput.closest("label");
        const noUpholsteryImg = noUpholsteryLabel && noUpholsteryLabel.querySelector("img");
        if (noUpholsteryImg) {
          noUpholsteryImg.src = prevImgSrc;
        }
        // If No Upholstery is currently selected, also update summary
        if (noUpholsteryInput.checked) {
          const target = noUpholsteryInput.dataset.name;
          const summarySelectionImg = document.querySelector(
            '.summary-selection[data-name="' + target + '"] img'
          );
          if (summarySelectionImg) {
            summarySelectionImg.src = prevImgSrc;
            summarySelectionImg.classList.remove("opacity-0");
          }
        }
      }
    }
  });
}

// Checkbox swatches: input.value stays the grouped option (e.g. "Leather") while data-value holds the SKU line ("Leather in Nero Pearl").
function optionStringForConfiguratorInput(input) {
  if (!input) return null;
  if (input.type !== "checkbox") return input.value;
  const dvRaw = input.getAttribute("data-value");
  if (dvRaw == null || String(dvRaw).trim() === "") return input.value;
  let dv = String(dvRaw)
    .replace(/\s*-+\s*$/, "")
    .trim();
  if (dv === "") return input.value;
  const pv = input.value;
  const special = pv === "No Upholstery" || pv === "Further Options";
  if (special || dv === pv || dv.includes(" in ")) return dv;
  return pv;
}

window.optionStringForConfiguratorInput = optionStringForConfiguratorInput;

function getVariantDetailOptionIndex(variantDetail) {
  if (!variantDetail) return -1;
  const raw = variantDetail.getAttribute("data-option-index");
  if (raw != null && raw !== "") {
    const n = parseInt(raw, 10);
    if (Number.isFinite(n) && n >= 0) return n;
  }
  return Array.from(getConfiguratorVariantDetails()).indexOf(variantDetail);
}

function getConfiguratorVariantDetails() {
  const root = document.querySelector(
    "#custom-configurator-form .variant-types"
  );
  if (root) {
    return root.querySelectorAll(
      ".variant-details:not(#variant-details-summary)"
    );
  }
  return document.querySelectorAll(
    ".variant-details:not(#variant-details-summary)"
  );
}

function getConfiguratorOptionInputFromDetail(variantDetail) {
  if (!variantDetail) return null;
  return (
    variantDetail.querySelector(
      '.details input[type="radio"]:checked, .details input[type="checkbox"]:checked'
    ) || variantDetail.querySelector(".details select")
  );
}

function getOptionValueIdFromInput(input) {
  if (!input) return null;
  if (input.tagName === "SELECT") {
    const opt = input.options[input.selectedIndex];
    if (!opt) return null;
    const oid = opt.getAttribute("data-option-value-id");
    return oid && String(oid).trim() ? String(oid).trim() : null;
  }
  const oid = input.getAttribute("data-option-value-id");
  return oid && String(oid).trim() ? String(oid).trim() : null;
}

function optionValuesMatch(variantOption, selectedValue) {
  return String(variantOption).trim() == String(selectedValue).trim();
}

function optionValueIdsMatch(variantId, selectedId) {
  if (variantId == null || selectedId == null || selectedId === "") return false;
  return String(variantId).trim() === String(selectedId).trim();
}

// Function to get selected options from custom configurator (index matches variant.options[])
function getCustomSelectedOptions() {
  const optionCount =
    typeof window.configuratorOptionCount === "number"
      ? window.configuratorOptionCount
      : getConfiguratorVariantDetails().length;
  const selectedOptions = new Array(optionCount).fill(null);

  getConfiguratorVariantDetails().forEach(function (variantDetail) {
    const optionIndex = getVariantDetailOptionIndex(variantDetail);
    if (optionIndex < 0 || optionIndex >= optionCount) return;

    const checkedInput = getConfiguratorOptionInputFromDetail(variantDetail);
    const selectEl =
      checkedInput && checkedInput.tagName === "SELECT"
        ? checkedInput
        : variantDetail.querySelector(".details select");

    if (checkedInput && checkedInput.tagName !== "SELECT") {
      selectedOptions[optionIndex] =
        optionStringForConfiguratorInput(checkedInput);
    } else if (selectEl) {
      const opt = selectEl.options[selectEl.selectedIndex];
      if (opt && opt.value) {
        selectedOptions[optionIndex] = String(opt.value).trim();
      }
    }
  });

  return selectedOptions;
}

window.getCustomSelectedOptions = getCustomSelectedOptions;

function getCustomSelectedOptionValueIds() {
  const optionCount =
    typeof window.configuratorOptionCount === "number"
      ? window.configuratorOptionCount
      : getConfiguratorVariantDetails().length;
  const selectedIds = new Array(optionCount).fill(null);

  getConfiguratorVariantDetails().forEach(function (variantDetail) {
    const optionIndex = getVariantDetailOptionIndex(variantDetail);
    if (optionIndex < 0 || optionIndex >= optionCount) return;
    const input = getConfiguratorOptionInputFromDetail(variantDetail);
    if (input) {
      selectedIds[optionIndex] = getOptionValueIdFromInput(input);
    }
  });

  return selectedIds;
}

window.getCustomSelectedOptionValueIds = getCustomSelectedOptionValueIds;

function clearConfiguratorNotActive() {
  const root = document.querySelector(
    "#custom-configurator-form .variant-types"
  );
  const scope = root || document;
  scope.querySelectorAll(".not-active").forEach(function (el) {
    el.classList.remove("not-active");
  });
}

const configuratorAvailabilityMapCache = Object.create(null);
let configuratorAvailabilityRunId = 0;

function canFilterConfiguratorAvailabilityClientSide() {
  return !window.productVariantsMayBeIncomplete;
}

function getConfiguratorSelectedOptionValuePrefix() {
  if (typeof window.compactOptionValueIdsForConfigurator === "function") {
    return window.compactOptionValueIdsForConfigurator();
  }
  const slots =
    typeof window.getConfiguratorOptionValueSlots === "function"
      ? window.getConfiguratorOptionValueSlots()
      : getCustomSelectedOptionValueIds();
  const prefix = [];
  for (let i = 0; i < slots.length; i++) {
    if (!slots[i]) break;
    prefix.push(String(slots[i]).trim());
  }
  return prefix;
}

/**
 * Shopify product_option_value.available for the current selection prefix (250+ safe).
 * One section render returns fresh data-option-available on each option input.
 */
function fetchConfiguratorAvailabilityMap(ovPrefix) {
  if (!ovPrefix || !ovPrefix.length) return Promise.resolve(null);

  const cacheKey = ovPrefix.join(",");
  if (
    Object.prototype.hasOwnProperty.call(
      configuratorAvailabilityMapCache,
      cacheKey
    )
  ) {
    return Promise.resolve(configuratorAvailabilityMapCache[cacheKey]);
  }

  const sectionId = window.configuratorSectionId;
  const getBase = window.getConfiguratorFetchBaseUrl;
  const appendQuery = window.appendQueryToBase;
  const defaultBase = window.configuratorDefaultProductUrl;
  const normalizePath = window.normalizeConfiguratorProductPath;

  if (
    !sectionId ||
    typeof getBase !== "function" ||
    typeof appendQuery !== "function"
  ) {
    return Promise.resolve(null);
  }

  const parts = [
    "section_id=" + encodeURIComponent(sectionId),
    "option_values=" + encodeURIComponent(ovPrefix.join(",")),
  ];

  function parseAvailabilityMap(html) {
    const map = Object.create(null);
    const tpl = document.createElement("template");
    tpl.innerHTML = html;
    const root = tpl.content;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const nodes = [];

    root.querySelectorAll("[data-option-value-id]").forEach(function (el) {
      nodes.push(el);
    });
    if (!nodes.length) {
      doc.querySelectorAll("[data-option-value-id]").forEach(function (el) {
        nodes.push(el);
      });
    }

    nodes.forEach(function (el) {
      const id = el.getAttribute("data-option-value-id");
      if (!id || !String(id).trim()) return;
      const availAttr = el.getAttribute("data-option-available");
      if (availAttr == null) return;
      const idKey = String(id).trim();
      const isAvailable = availAttr === "true";
      if (map[idKey] !== true) {
        map[idKey] = isAvailable;
      }
    });

    return map;
  }

  function tryFetch(base) {
    const url = appendQuery(base, parts);
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error("availability fetch failed");
      return r.text();
    });
  }

  const fetchBase = getBase();
  return tryFetch(fetchBase)
    .catch(function () {
      if (
        defaultBase &&
        typeof normalizePath === "function" &&
        normalizePath(fetchBase) !== normalizePath(defaultBase)
      ) {
        return tryFetch(defaultBase);
      }
      throw new Error("availability fetch failed");
    })
    .then(function (html) {
      const map = parseAvailabilityMap(html);
      configuratorAvailabilityMapCache[cacheKey] = map;
      return map;
    })
    .catch(function () {
      return null;
    });
}

function isOptionValueIdAvailableFromMap(map, optionValueId) {
  if (!map || !optionValueId) return true;
  const key = String(optionValueId).trim();
  if (!Object.prototype.hasOwnProperty.call(map, key)) return true;
  return map[key] === true;
}

/** Prefix of option_value ids for options before optionIndex (not including later picks). */
function buildConfiguratorOvPrefixBeforeOption(
  selectedOptionValueIds,
  optionIndex
) {
  if (optionIndex < 1) return null;
  const prefix = [];
  for (let idx = 0; idx < optionIndex; idx++) {
    const id = selectedOptionValueIds[idx];
    if (!id) return null;
    prefix.push(String(id).trim());
  }
  return prefix.length === optionIndex ? prefix : null;
}

function getConfiguratorVariantDetailByOptionIndex(optionIndex) {
  return Array.from(getConfiguratorVariantDetails()).find(function (vd) {
    return getVariantDetailOptionIndex(vd) === optionIndex;
  });
}

function applyConfiguratorAvailabilityForOptionIndex(
  map,
  optionIndex,
  selectedOptions,
  selectedOptionValueIds
) {
  const variantDetail = getConfiguratorVariantDetailByOptionIndex(optionIndex);
  if (!variantDetail) return;
  if (
    !hasPriorOptionSelection(
      selectedOptions,
      selectedOptionValueIds,
      optionIndex
    )
  ) {
    return;
  }

  forEachConfiguratorChoices(variantDetail, function (meta) {
    if (!meta.id) {
      markChoiceNotActive(meta.container, false);
      return;
    }
    if (meta.input && meta.input.checked) {
      if (isOptionValueIdAvailableFromMap(map, meta.id)) {
        markChoiceNotActive(meta.container, false);
      } else {
        markChoiceNotActive(meta.container, true);
      }
      return;
    }
    markChoiceNotActive(
      meta.container,
      !isOptionValueIdAvailableFromMap(map, meta.id)
    );
  });
}

function syncConfiguratorSoleOptionSelectionForDetail(
  variantDetail,
  optionIndex,
  map,
  selectedOptions,
  selectedOptionValueIds
) {
  if (!map || !variantDetail) return false;

  const available = [];
  forEachConfiguratorChoices(variantDetail, function (meta) {
    if (!meta.id) return;
    if (isOptionValueIdAvailableFromMap(map, meta.id)) {
      available.push(meta);
    }
  });

  const currentInput = getConfiguratorOptionInputFromDetail(variantDetail);
  let changed = false;

  if (available.length === 1) {
    const sole = available[0];
    if (!isConfiguratorChoiceSelected(sole, variantDetail)) {
      applyConfiguratorOptionSelectionUI(sole.input, variantDetail, sole.labelEl, {
        autoSelected: true,
      });
      changed = true;
    } else if (currentInput) {
      currentInput.dataset.autoSelected = "true";
    }
  } else if (available.length > 1 && currentInput) {
    if (currentInput.dataset.autoSelected === "true") {
      clearConfiguratorOptionSelectionUI(currentInput, variantDetail);
      changed = true;
    }
  }

  if (changed) {
    if (typeof updateMatchingUpholstery === "function") {
      updateMatchingUpholstery();
    }
    if (typeof updateFormProperties === "function") {
      updateFormProperties();
    }
    checkAndShowForm();
  }

  return changed;
}

function invalidateConfiguratorAvailabilityCache() {
  Object.keys(configuratorAvailabilityMapCache).forEach(function (key) {
    delete configuratorAvailabilityMapCache[key];
  });
}

function getConfiguratorStepsToMarkAvailability(
  selectedOptions,
  selectedOptionValueIds,
  optionCount
) {
  const indices = [];
  for (let optionIndex = 1; optionIndex < optionCount; optionIndex++) {
    if (
      !hasPriorOptionSelection(
        selectedOptions,
        selectedOptionValueIds,
        optionIndex
      )
    ) {
      continue;
    }
    const prefix = buildConfiguratorOvPrefixBeforeOption(
      selectedOptionValueIds,
      optionIndex
    );
    if (!prefix || !prefix.length) continue;
    indices.push(optionIndex);
  }
  return indices;
}

/** Call when the user changes any configurator option (especially earlier steps). */
function notifyConfiguratorOptionChanged(changedOptionIndex) {
  invalidateConfiguratorAvailabilityCache();
  configuratorAvailabilityRunId++;

  if (typeof changedOptionIndex === "number" && changedOptionIndex >= 0) {
    getConfiguratorVariantDetails().forEach(function (vd) {
      const idx = getVariantDetailOptionIndex(vd);
      if (idx > changedOptionIndex) {
        vd.querySelectorAll(".not-active").forEach(function (el) {
          el.classList.remove("not-active");
        });
      }
    });
  }

  updateConfiguratorOptionAvailability();
}

window.notifyConfiguratorOptionChanged = notifyConfiguratorOptionChanged;

/** True if any earlier step has a selection (filter upcoming steps only). */
function hasPriorOptionSelection(selectedOptions, selectedOptionValueIds, optionIndex) {
  for (let idx = 0; idx < optionIndex; idx++) {
    if (selectedOptionValueIds[idx]) return true;
    const sel = selectedOptions[idx];
    if (sel != null && sel !== "") return true;
  }
  return false;
}

function variantMatchesChoiceWithPriorSelections(
  v,
  optionIndex,
  optionValue,
  optionValueId,
  selectedOptions,
  selectedOptionValueIds
) {
  if (!v.options || optionIndex >= v.options.length) return false;

  let matchesChoice = false;
  if (
    optionValueId &&
    v.option_value_ids &&
    v.option_value_ids[optionIndex] != null
  ) {
    matchesChoice = optionValueIdsMatch(
      v.option_value_ids[optionIndex],
      optionValueId
    );
  }
  if (!matchesChoice && optionValue != null && optionValue !== "") {
    matchesChoice = optionValuesMatch(v.options[optionIndex], optionValue);
  }
  if (!matchesChoice) return false;

  for (let idx = 0; idx < optionIndex; idx++) {
    const selId = selectedOptionValueIds[idx];
    const selStr = selectedOptions[idx];
    if (selId && v.option_value_ids && v.option_value_ids[idx] != null) {
      if (!optionValueIdsMatch(v.option_value_ids[idx], selId)) return false;
    } else if (selStr != null && selStr !== "") {
      if (!optionValuesMatch(v.options[idx], selStr)) return false;
    }
  }
  return true;
}

/** True when a variant exists for this choice given earlier selections only. */
function isOptionChoiceAvailable(
  optionIndex,
  optionValue,
  optionValueId,
  selectedOptions,
  selectedOptionValueIds
) {
  if (!window.productVariants || !window.productVariants.length) return true;
  if (
    (optionValue == null || optionValue === "") &&
    (optionValueId == null || optionValueId === "")
  ) {
    return true;
  }

  return window.productVariants.some(function (v) {
    return variantMatchesChoiceWithPriorSelections(
      v,
      optionIndex,
      optionValue,
      optionValueId,
      selectedOptions,
      selectedOptionValueIds
    );
  });
}

function getOptionValueAndIdFromInput(input) {
  if (!input) return { value: null, id: null };
  let value = null;
  if (input.tagName === "SELECT") {
    const opt = input.options[input.selectedIndex];
    value = opt && opt.value ? String(opt.value).trim() : null;
  } else if (input.type === "checkbox") {
    value = input.checked
      ? optionStringForConfiguratorInput(input)
      : input.value;
  } else {
    value =
      input.getAttribute("data-value") != null &&
      String(input.getAttribute("data-value")).trim() !== ""
        ? String(input.getAttribute("data-value")).trim()
        : input.value;
  }
  return { value: value, id: getOptionValueIdFromInput(input) };
}

function getChoiceContainerForInput(input) {
  if (!input) return null;
  const variantDetail = input.closest(".variant-details");
  if (!variantDetail) return null;

  const optionGroup = input.closest(".group");
  if (optionGroup) return optionGroup;

  const selectedSwatch = variantDetail.querySelector(".swatch-item.bg-gray-100");
  if (selectedSwatch) {
    const swatchFor = selectedSwatch.getAttribute("for");
    if (swatchFor === input.id || selectedSwatch.querySelector("input") === input) {
      return selectedSwatch;
    }
  }

  let label = null;
  if (input.id) {
    label = document.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]');
  }
  if (label) {
    return (
      label.closest(".swatch-item") ||
      label.closest(".swatch-group") ||
      label.closest(".no-upholstery-link") ||
      label.closest(".group") ||
      label
    );
  }

  return (
    input.closest(".swatch-group") ||
    input.closest(".no-upholstery-link") ||
    input.closest(".group") ||
    input.parentElement
  );
}

function getOptionValueForSwatchLabel(label) {
  const item = label.getAttribute("data-swatch-item");
  const parent = label.getAttribute("data-parent");
  if (item) {
    return parent ? parent + " in " + item : item;
  }
  const inputId = label.getAttribute("for");
  const input = inputId
    ? document.getElementById(inputId)
    : label.querySelector("input.basic-radio");
  if (!input) return null;
  if (input.checked) return optionStringForConfiguratorInput(input);
  return input.value;
}

function markChoiceNotActive(element, inactive) {
  if (!element) return;
  if (inactive) {
    element.classList.add("not-active");
  } else {
    element.classList.remove("not-active");
  }
}

/** Clear a configurator option input and sync sidebar/summary UI. */
function clearConfiguratorOptionSelectionUI(input, variantDetail) {
  if (!input || !variantDetail) return false;

  const hadSelection =
    input.tagName === "SELECT"
      ? !!input.value
      : input.checked;
  if (!hadSelection) return false;

  const target = input.dataset.name;
  const dataValueBeforeClear = input.getAttribute("data-value") || "";

  if (input.tagName === "SELECT") {
    input.selectedIndex = 0;
    if (input.options[0]) input.options[0].selected = true;
  } else {
    input.checked = false;
    input.removeAttribute("checked");
    if (input.type === "checkbox") {
      input.setAttribute("data-value", "");
      input.setAttribute("data-img", "");
    }
  }

  variantDetail.querySelectorAll(".swatch-item.bg-gray-100").forEach(function (el) {
    el.classList.remove("bg-gray-100");
  });
  variantDetail.querySelectorAll(".selected-text-holder").forEach(function (holder) {
    holder.style.height = "0";
    holder.style.opacity = "0";
  });

  if (target) {
    document.querySelectorAll('.selection[data-name="' + target + '"]').forEach(
      function (item) {
        item.classList.add("opacity-50");
        item.innerHTML = "Make Selection";
        const configuratorBtn = item.closest(".configurator-btn");
        if (configuratorBtn) configuratorBtn.classList.remove("active");
      }
    );
    const summarySelectionText = document.querySelector(
      '.summary-selection[data-name="' + target + '"] .selection'
    );
    const summarySelectionImg = document.querySelector(
      '.summary-selection[data-name="' + target + '"] img'
    );
    if (summarySelectionText) {
      summarySelectionText.innerHTML = "Make Selection";
    }
    if (summarySelectionImg) {
      summarySelectionImg.classList.add("opacity-0");
    }
  }

  if (
    input.type === "checkbox" &&
    (dataValueBeforeClear.includes(" in ") ||
      dataValueBeforeClear === "No Upholstery")
  ) {
    const materialInput = document.querySelector("input#line-material");
    if (materialInput) materialInput.value = "";
    const simpleMaterialInput = document.querySelector("input#simple-line-material");
    if (simpleMaterialInput) simpleMaterialInput.value = "";
  }

  delete input.dataset.autoSelected;

  return true;
}

/** Sync sidebar / summary labels after a programmatic or user selection. */
function updateConfiguratorSelectionDisplay(input) {
  if (!input || !input.dataset.name) return;

  const target = input.dataset.name;
  const displayValue =
    input.getAttribute("data-value") ||
    input.dataset.value ||
    input.value ||
    "";
  let targetImg = input.dataset.img;
  if (targetImg == "nil" || targetImg == "") {
    targetImg = null;
  }

  document.querySelectorAll('.selection[data-name="' + target + '"]').forEach(
    function (item) {
      item.classList.remove("opacity-50");
      item.innerHTML = displayValue;
      const configuratorBtn = item.closest(".configurator-btn");
      if (configuratorBtn) configuratorBtn.classList.add("active");
    }
  );

  const summarySelectionText = document.querySelector(
    '.summary-selection[data-name="' + target + '"] .selection'
  );
  const summarySelectionImg = document.querySelector(
    '.summary-selection[data-name="' + target + '"] img'
  );

  if (summarySelectionText) {
    summarySelectionText.innerHTML = displayValue;
  }

  if (summarySelectionImg) {
    if (targetImg != null) {
      summarySelectionImg.src = targetImg;
      summarySelectionImg.classList.remove("opacity-0");
    } else {
      summarySelectionImg.classList.add("opacity-0");
    }
  }
}

function applyConfiguratorOptionSelectionUI(input, variantDetail, labelEl, opts) {
  if (!input || !variantDetail) return false;

  const autoSelected = !!(opts && opts.autoSelected);

  if (input.type === "radio" && input.name) {
    variantDetail.querySelectorAll('input[type="radio"]').forEach(function (r) {
      if (r.name === input.name) {
        r.checked = false;
        r.removeAttribute("checked");
        delete r.dataset.autoSelected;
      }
    });
  }

  if (labelEl && labelEl.classList.contains("swatch-item")) {
    variantDetail.querySelectorAll(".swatch-item.bg-gray-100").forEach(function (el) {
      el.classList.remove("bg-gray-100");
    });
    labelEl.classList.add("bg-gray-100");

    const swatchItem = labelEl.getAttribute("data-swatch-item");
    const parentSet = labelEl.getAttribute("data-parent");
    const isNoUpholstery =
      input.value === "No Upholstery" ||
      input.value === "Further Options" ||
      !swatchItem;

    if (isNoUpholstery) {
      input.setAttribute("data-value", input.value);
    } else if (swatchItem && parentSet) {
      input.setAttribute("data-value", parentSet + " in " + swatchItem);
      const materialInput = document.querySelector("input#line-material");
      if (materialInput) {
        materialInput.value = parentSet + " in " + swatchItem;
      }
      const simpleMaterialInput = document.querySelector("input#simple-line-material");
      if (simpleMaterialInput) {
        simpleMaterialInput.value = parentSet + " in " + swatchItem;
      }
    }
  } else if (input.type === "radio") {
    input.setAttribute("data-value", input.value);
  }

  input.checked = true;
  input.setAttribute("checked", "checked");

  if (autoSelected) {
    input.dataset.autoSelected = "true";
  } else {
    delete input.dataset.autoSelected;
  }

  updateConfiguratorSelectionDisplay(input);
  return true;
}

function shouldSkipConfiguratorAvailabilityInput(input) {
  return (
    input &&
    input.closest(".swatch-group") &&
    !input.closest(".no-upholstery-link") &&
    input.closest(".swatch-set")
  );
}

function resolveConfiguratorChoiceMeta(input, labelEl) {
  if (!input) return null;

  let value = null;
  let id = getOptionValueIdFromInput(input);

  if (labelEl && labelEl.getAttribute("data-swatch-item")) {
    value = getOptionValueForSwatchLabel(labelEl);
  } else {
    const picked = getOptionValueAndIdFromInput(input);
    value = input.checked ? picked.value : picked.value || input.value;
    id = picked.id || id;
  }

  if (!value && !id) return null;

  const container =
    labelEl ||
    getChoiceContainerForInput(input) ||
    input.closest(".group") ||
    input.closest(".swatch-item") ||
    input.closest(".no-upholstery-link");

  return { input: input, labelEl: labelEl, value: value, id: id, container: container };
}

function forEachConfiguratorChoices(variantDetail, callback) {
  const seenInputs = new Set();

  variantDetail
    .querySelectorAll(
      '.details input[type="radio"], .details input[type="checkbox"].basic-radio'
    )
    .forEach(function (input) {
      if (shouldSkipConfiguratorAvailabilityInput(input) || seenInputs.has(input)) {
        return;
      }
      seenInputs.add(input);
      const meta = resolveConfiguratorChoiceMeta(input, null);
      if (meta) callback(meta);
    });

  variantDetail.querySelectorAll(".swatch-item").forEach(function (label) {
    const inputId = label.getAttribute("for");
    const input = inputId
      ? document.getElementById(inputId)
      : label.querySelector("input.basic-radio");
    if (!input || seenInputs.has(input)) return;
    seenInputs.add(input);
    const meta = resolveConfiguratorChoiceMeta(input, label);
    if (meta) callback(meta);
  });
}

function getAvailableConfiguratorChoices(
  variantDetail,
  optionIndex,
  selectedOptions,
  selectedOptionValueIds
) {
  const choices = [];
  const seenKeys = new Set();

  forEachConfiguratorChoices(variantDetail, function (meta) {
    if (
      !isOptionChoiceAvailable(
        optionIndex,
        meta.value,
        meta.id,
        selectedOptions,
        selectedOptionValueIds
      )
    ) {
      return;
    }
    const key = (meta.id || "") + "::" + (meta.value || "");
    if (seenKeys.has(key)) return;
    seenKeys.add(key);
    choices.push(meta);
  });

  return choices;
}

function isConfiguratorChoiceSelected(choice, variantDetail) {
  const current = getConfiguratorOptionInputFromDetail(variantDetail);
  if (!current || !current.checked) return false;

  if (current === choice.input) {
    if (choice.labelEl && choice.labelEl.classList.contains("bg-gray-100")) {
      return true;
    }
    if (!choice.labelEl) return true;
  }

  const currentVal = optionStringForConfiguratorInput(current);
  const currentId = getOptionValueIdFromInput(current);
  if (choice.id && currentId && optionValueIdsMatch(currentId, choice.id)) {
    return true;
  }
  return optionValuesMatch(currentVal, choice.value);
}

/**
 * Auto-select when only one value is available; clear auto-pick when several return.
 */
function syncConfiguratorSoleOptionSelection() {
  if (!window.productVariants || !window.productVariants.length) return false;

  let changed = false;
  let selectedOptions = getCustomSelectedOptions();
  let selectedOptionValueIds = getCustomSelectedOptionValueIds();

  getConfiguratorVariantDetails().forEach(function (variantDetail) {
    const optionIndex = getVariantDetailOptionIndex(variantDetail);
    if (optionIndex < 0) return;
    if (
      !hasPriorOptionSelection(
        selectedOptions,
        selectedOptionValueIds,
        optionIndex
      )
    ) {
      return;
    }

    const available = getAvailableConfiguratorChoices(
      variantDetail,
      optionIndex,
      selectedOptions,
      selectedOptionValueIds
    );
    const currentInput = getConfiguratorOptionInputFromDetail(variantDetail);

    if (available.length === 1) {
      const sole = available[0];
      if (!isConfiguratorChoiceSelected(sole, variantDetail)) {
        applyConfiguratorOptionSelectionUI(sole.input, variantDetail, sole.labelEl, {
          autoSelected: true,
        });
        changed = true;
        selectedOptions = getCustomSelectedOptions();
        selectedOptionValueIds = getCustomSelectedOptionValueIds();
      } else if (currentInput && currentInput.dataset.autoSelected !== "true") {
        // User picked the only option — do not treat as auto so it won't clear when more open up
      } else if (currentInput) {
        currentInput.dataset.autoSelected = "true";
      }
    } else if (available.length > 1 && currentInput) {
      if (currentInput.dataset.autoSelected === "true") {
        clearConfiguratorOptionSelectionUI(currentInput, variantDetail);
        changed = true;
        selectedOptions = getCustomSelectedOptions();
        selectedOptionValueIds = getCustomSelectedOptionValueIds();
      }
    }
  });

  if (changed) {
    if (typeof updateMatchingUpholstery === "function") {
      updateMatchingUpholstery();
    }
    if (typeof updateFormProperties === "function") {
      updateFormProperties();
    }
    triggerVariantChangeDebounced();
    checkAndShowForm();
  }

  return changed;
}

/**
 * Remove selections in later steps that are invalid for earlier selections.
 */
function clearInvalidConfiguratorSelections() {
  if (!window.productVariants || !window.productVariants.length) return false;

  const optionCount =
    typeof window.configuratorOptionCount === "number"
      ? window.configuratorOptionCount
      : getConfiguratorVariantDetails().length;

  let anyCleared = false;
  let selectedOptions = getCustomSelectedOptions();
  let selectedOptionValueIds = getCustomSelectedOptionValueIds();

  for (let optionIndex = 0; optionIndex < optionCount; optionIndex++) {
    if (
      !hasPriorOptionSelection(
        selectedOptions,
        selectedOptionValueIds,
        optionIndex
      )
    ) {
      continue;
    }

    const selStr = selectedOptions[optionIndex];
    const selId = selectedOptionValueIds[optionIndex];
    if (!selStr && !selId) continue;

    const available = isOptionChoiceAvailable(
      optionIndex,
      selStr,
      selId,
      selectedOptions,
      selectedOptionValueIds
    );

    if (available) continue;

    const variantDetail = Array.from(getConfiguratorVariantDetails()).find(
      function (vd) {
        return getVariantDetailOptionIndex(vd) === optionIndex;
      }
    );
    const input = variantDetail
      ? getConfiguratorOptionInputFromDetail(variantDetail)
      : null;

    if (clearConfiguratorOptionSelectionUI(input, variantDetail)) {
      anyCleared = true;
      selectedOptions = getCustomSelectedOptions();
      selectedOptionValueIds = getCustomSelectedOptionValueIds();
    }
  }

  if (anyCleared) {
    if (typeof updateMatchingUpholstery === "function") {
      updateMatchingUpholstery();
    }
    if (typeof updateFormProperties === "function") {
      updateFormProperties();
    }
    triggerVariantChangeDebounced();
    checkAndShowForm();
  }

  return anyCleared;
}

window.clearInvalidConfiguratorSelections = clearInvalidConfiguratorSelections;

function applyConfiguratorAvailabilityMarks(
  selectedOptions,
  selectedOptionValueIds
) {
  getConfiguratorVariantDetails().forEach(function (variantDetail) {
    const optionIndex = getVariantDetailOptionIndex(variantDetail);
    if (optionIndex < 0) return;
    if (
      !hasPriorOptionSelection(
        selectedOptions,
        selectedOptionValueIds,
        optionIndex
      )
    ) {
      return;
    }

    forEachConfiguratorChoices(variantDetail, function (meta) {
      markChoiceNotActive(
        meta.container,
        !isOptionChoiceAvailable(
          optionIndex,
          meta.value,
          meta.id,
          selectedOptions,
          selectedOptionValueIds
        )
      );
    });
  });
}

function runConfiguratorAvailabilityUpdate() {
  if (!window.productVariants || !window.productVariants.length) return;

  clearInvalidConfiguratorSelections();
  clearConfiguratorNotActive();

  const selectedOptions = getCustomSelectedOptions();
  const selectedOptionValueIds = getCustomSelectedOptionValueIds();
  const hasAnySelection =
    selectedOptions.some(function (s) {
      return s != null && s !== "";
    }) ||
    selectedOptionValueIds.some(function (id) {
      return id != null && id !== "";
    });
  if (!hasAnySelection) return;

  applyConfiguratorAvailabilityMarks(selectedOptions, selectedOptionValueIds);

  if (syncConfiguratorSoleOptionSelection()) {
    clearConfiguratorNotActive();
    applyConfiguratorAvailabilityMarks(
      getCustomSelectedOptions(),
      getCustomSelectedOptionValueIds()
    );
  }
}

function runConfiguratorAvailabilityUpdateViaServer(recursionDepth) {
  recursionDepth = recursionDepth || 0;
  const runId = ++configuratorAvailabilityRunId;

  const selectedOptions = getCustomSelectedOptions();
  const selectedOptionValueIds = getCustomSelectedOptionValueIds();
  const optionCount =
    typeof window.configuratorOptionCount === "number"
      ? window.configuratorOptionCount
      : getConfiguratorVariantDetails().length;

  if (
    !selectedOptionValueIds[0] &&
    !selectedOptions[0]
  ) {
    return;
  }

  const indicesToMark = getConfiguratorStepsToMarkAvailability(
    selectedOptions,
    selectedOptionValueIds,
    optionCount
  );
  if (!indicesToMark.length) return;

  let firstEmptyIndex = optionCount;
  for (let i = 0; i < optionCount; i++) {
    if (!selectedOptionValueIds[i]) {
      firstEmptyIndex = i;
      break;
    }
  }

  const fetchTasks = indicesToMark.map(function (optionIndex) {
    const prefix = buildConfiguratorOvPrefixBeforeOption(
      selectedOptionValueIds,
      optionIndex
    );
    return fetchConfiguratorAvailabilityMap(prefix).then(function (map) {
      return { optionIndex: optionIndex, map: map };
    });
  });

  Promise.all(fetchTasks).then(function (results) {
    if (runId !== configuratorAvailabilityRunId) return;

    let needsAnotherPass = false;
    let soleChanged = false;
    const liveOptions = getCustomSelectedOptions();
    const liveIds = getCustomSelectedOptionValueIds();

    results.forEach(function (result) {
      if (!result || !result.map || !Object.keys(result.map).length) return;

      const variantDetail = getConfiguratorVariantDetailByOptionIndex(
        result.optionIndex
      );
      const selId = liveIds[result.optionIndex];

      if (
        selId &&
        !isOptionValueIdAvailableFromMap(result.map, selId) &&
        variantDetail
      ) {
        const input = getConfiguratorOptionInputFromDetail(variantDetail);
        if (clearConfiguratorOptionSelectionUI(input, variantDetail)) {
          needsAnotherPass = true;
        }
      }
    });

    const refreshedOptions = getCustomSelectedOptions();
    const refreshedIds = getCustomSelectedOptionValueIds();

    results.forEach(function (result) {
      if (!result || !result.map || !Object.keys(result.map).length) return;

      applyConfiguratorAvailabilityForOptionIndex(
        result.map,
        result.optionIndex,
        refreshedOptions,
        refreshedIds
      );
    });

    if (firstEmptyIndex < optionCount) {
      const frontierDetail = getConfiguratorVariantDetailByOptionIndex(
        firstEmptyIndex
      );
      const frontierResult = results.find(function (r) {
        return r && r.optionIndex === firstEmptyIndex;
      });
      if (
        frontierResult &&
        frontierResult.map &&
        frontierDetail &&
        syncConfiguratorSoleOptionSelectionForDetail(
          frontierDetail,
          firstEmptyIndex,
          frontierResult.map,
          getCustomSelectedOptions(),
          getCustomSelectedOptionValueIds()
        )
      ) {
        soleChanged = true;
        needsAnotherPass = true;
      }
    }

    if (needsAnotherPass && recursionDepth < 3) {
      runConfiguratorAvailabilityUpdateViaServer(recursionDepth + 1);
      return;
    }

    if (soleChanged) {
      triggerVariantChangeDebounced();
    }
  });
}

/**
 * Later options get .not-active when no variant matches earlier picks.
 * 250+ products use one section fetch; Liquid sets data-option-available per option value.
 */
let configuratorAvailabilityDebounce = null;

function updateConfiguratorOptionAvailability() {
  if (canFilterConfiguratorAvailabilityClientSide()) {
    runConfiguratorAvailabilityUpdate();
    return;
  }

  if (configuratorAvailabilityDebounce) {
    clearTimeout(configuratorAvailabilityDebounce);
  }
  configuratorAvailabilityDebounce = setTimeout(function () {
    configuratorAvailabilityDebounce = null;
    runConfiguratorAvailabilityUpdateViaServer();
  }, 120);
}

window.updateConfiguratorOptionAvailability = updateConfiguratorOptionAvailability;

/** True if variant satisfies every picked option (null / empty slot = wildcard). */
function variantMatchesPartialSelection(variant, selectedOptions) {
  if (!variant || !variant.options) return false;
  if (!selectedOptions.length) return true;
  for (let idx = 0; idx < selectedOptions.length; idx++) {
    const sel = selectedOptions[idx];
    if (sel == null || sel === "") continue;
    if (variant.options[idx] != sel) return false;
  }
  return true;
}

function numericVariantPrice(variant) {
  if (!variant || variant.price == null) return Infinity;
  const n = Number(variant.price);
  return Number.isFinite(n) ? n : Infinity;
}

/**
 * When Shopify caps product.variants in Liquid (~250), we cannot derive true min/partial pricing in JS.
 * Partial → null + section fetch uses ?option_values=… (server-side catalogue).
 * Full → only trust a variant object if present in embedded JSON (exact match).
 */
function findVariantForConfiguratorPricing(selectedOptions) {
  if (!window.productVariants || !window.productVariants.length) return null;

  const allPositionsFilled = selectedOptions.every(function (v) {
    return v != null && v !== "";
  });

  if (window.productVariantsMayBeIncomplete) {
    if (!allPositionsFilled) {
      return null;
    }
    const exactLoaded = window.productVariants.find(function (v) {
      return v.options.every(function (opt, idx) {
        return opt == selectedOptions[idx];
      });
    });
    return exactLoaded || null;
  }

  const matches = window.productVariants.filter(function (v) {
    return variantMatchesPartialSelection(v, selectedOptions);
  });

  if (!matches.length) {
    return findBestMatchingVariant(selectedOptions);
  }

  if (allPositionsFilled) {
    const exact = matches.find(function (v) {
      return v.options.every(function (opt, idx) {
        return opt == selectedOptions[idx];
      });
    });
    // Do not fall back to matches[0] — option strings from swatches/checkboxes often
    // won't equal variant.options[] even when the selection is valid; caller uses
    // ?option_values= + server-resolved variant id instead.
    return exact || null;
  }

  return matches.reduce(function (cheapest, v) {
    return numericVariantPrice(v) < numericVariantPrice(cheapest) ? v : cheapest;
  }, matches[0]);
}

window.findVariantForConfiguratorPricing = findVariantForConfiguratorPricing;

// Function to find best matching variant with partial selections (fallback when no price-aware match)
function findBestMatchingVariant(selectedOptions) {
  if (!window.productVariants) return null;

  // First try to find exact match
  let variant = window.productVariants.find(function (variant) {
    return variant.options.every(function (opt, idx) {
      return opt == selectedOptions[idx];
    });
  });

  // If no exact match, find the variant that matches the most selected options
  if (!variant) {
    let bestMatch = null;
    let bestMatchCount = 0;

    window.productVariants.forEach(function (variant) {
      let matchCount = 0;
      variant.options.forEach(function (opt, idx) {
        if (selectedOptions[idx] && opt == selectedOptions[idx]) {
          matchCount++;
        }
      });

      if (matchCount > bestMatchCount) {
        bestMatchCount = matchCount;
        bestMatch = variant;
      }
    });

    variant = bestMatch;
  }

  // If still no match, use the first available variant
  if (!variant && window.productVariants.length > 0) {
    variant = window.productVariants[0];
  }

  return variant;
}

// Debounced version of triggerVariantChange to prevent multiple rapid calls
let triggerVariantChangeTimeout = null;
function triggerVariantChangeDebounced() {
  if (triggerVariantChangeTimeout) {
    clearTimeout(triggerVariantChangeTimeout);
  }
  triggerVariantChangeTimeout = setTimeout(function() {
    triggerVariantChange();
  }, 100);
}

// Flag to track if user has manually selected a variant (not initial load)
let userHasSelectedVariant = false;

window.configuratorUserHasSelected = function () {
  return userHasSelectedVariant;
};

window.markConfiguratorUserSelected = function () {
  userHasSelectedVariant = true;
};

function hideFromPrefixIfSelected() {
  if (!userHasSelectedVariant) return;
  if (typeof window.hideFromPrefix === "function") {
    window.hideFromPrefix();
    return;
  }
  document.documentElement.classList.add("sj-from-disabled");
  document.querySelectorAll(".from-prefix").forEach(function (el) {
    el.style.display = "none";
  });
  window.__sjFromPrefixDisabled = true;
}

window.hideFromPrefixIfSelected = hideFromPrefixIfSelected;

// Function to hide from-price and show main-price items
// Uses inline styles to persist even when HTML is replaced
function hideFromPriceShowMainPrice() {
  // Only hide/show if user has manually selected a variant
  if (!userHasSelectedVariant) {
    return;
  }

  hideFromPrefixIfSelected();

  const fromPriceItems = document.querySelectorAll(".from-price");
  const mainPriceItems = document.querySelectorAll(".main-price");
  
  fromPriceItems.forEach((item) => {
    item.style.display = "none";
  });
  
  mainPriceItems.forEach((item) => {
    item.style.display = "";
    item.classList.remove("hidden");
  });
}

// Make function globally available
window.hideFromPriceShowMainPrice = hideFromPriceShowMainPrice;

// Function to trigger variant change and price update
function triggerVariantChange() {
  const selectedOptions = getCustomSelectedOptions();
  updateConfiguratorOptionAvailability();
  const variant = findVariantForConfiguratorPricing(selectedOptions);
  const allOptionsFilled = selectedOptions.every(function (sel) {
    return sel != null && sel !== "";
  });

  if (userHasSelectedVariant) {
    if (typeof updatePriceDisplay === "function") {
      updatePriceDisplay(variant);
    }

    if (variant && variant.id) {
      updateConfiguratorSubtotalFromVariant(variant);
    }
  }

  var canResolveVariantOnServer =
    typeof window.configuratorOvSelectionComplete === "function" &&
    window.configuratorOvSelectionComplete();

  if (!(variant && variant.id) && !window.productVariantsMayBeIncomplete) {
    if (!canResolveVariantOnServer) {
      console.log("❌ No variant for pricing");
      return;
    }
  }

  setTimeout(function () {
    hideFromPriceShowMainPrice();
  }, 100);

  if (!allOptionsFilled || !userHasSelectedVariant) {
    return;
  }

  function applyResolvedConfiguratorVariant(variantObj) {
    if (!(variantObj && variantObj.id)) return;

    var variantInput = document.getElementById("custom-configurator-variant-id");
    var simpleVariantInput = document.getElementById("simple-configurator-variant-id");
    if (variantInput) variantInput.value = variantObj.id;
    if (simpleVariantInput) simpleVariantInput.value = variantObj.id;

    updateConfiguratorSubtotalFromVariant(variantObj);

    if (typeof window.updateProductUrl === "function") {
      var urlToSet = null;
      if (typeof window.buildConfiguratorVariantBrowserUrl === "function") {
        urlToSet = window.buildConfiguratorVariantBrowserUrl(variantObj.id);
      }
      if (!urlToSet) {
        urlToSet =
          window.location.pathname + "?variant=" + encodeURIComponent(String(variantObj.id));
      }
      if (urlToSet) {
        window.updateProductUrl(urlToSet);
      }
    }
    if (typeof window.updateFormProperties === "function") {
      window.updateFormProperties();
    }
    if (typeof window.updateEnquiryModalFromCustom === "function") {
      window.updateEnquiryModalFromCustom(variantObj);
    }
    if (typeof handleChange === "function") {
      handleChange();
    }
    document.dispatchEvent(
      new CustomEvent("variant:change", {
        detail: { variant: variantObj },
      })
    );
    console.log("🚀 Variant change event dispatched:", variantObj.id);
  }

  if (variant && variant.id) {
    applyResolvedConfiguratorVariant(variant);
    return;
  }

  var ovComplete =
    typeof window.configuratorOvSelectionComplete === "function" &&
    window.configuratorOvSelectionComplete();

  if (
    typeof window.fetchConfiguratorResolvedVariantId === "function" &&
    (window.productVariantsMayBeIncomplete || ovComplete)
  ) {
    window.fetchConfiguratorResolvedVariantId().then(function (idStr) {
      if (!idStr) return;
      var embedded =
        window.productVariants &&
        window.productVariants.find(function (x) {
          return String(x.id) === String(idStr);
        });
      applyResolvedConfiguratorVariant(embedded || { id: idStr });
    });
  }
}

// Function to check if all configurator buttons are active and show form
function checkAndShowForm() {
  const configuratorButtons = document.querySelectorAll(".configurator-btn");
  const formB = document.querySelector(".custom-configurator.form-b");
  const configSpacer = document.querySelector(".config-spacer");

  if (!configuratorButtons.length || !formB) {
    return;
  }

  // Check if all buttons have the active class
  const allActive = Array.from(configuratorButtons).every((button) =>
    button.classList.contains("active")
  );

  if (allActive) {
    // Remove hidden class and add flex class
    formB.classList.remove("hidden");
    formB.classList.add("flex");
    // Hide config-spacer when form is shown
    if (configSpacer) {
      configSpacer.classList.add("hidden");
    }
  } else {
    // Add hidden class and remove flex class
    formB.classList.add("hidden");
    formB.classList.remove("flex");
    // Show config-spacer when form is hidden
    if (configSpacer) {
      configSpacer.classList.remove("hidden");
    }
  }
}



// swatch restyle if all images empty
document.addEventListener("DOMContentLoaded", function () {
  // Find all .swatch-variants containers
  const swatchVariants = document.querySelectorAll(".details-inner.swatch-variants");
  swatchVariants.forEach(function (swatchSet) {
    // Find all <img> elements inside this swatch-variants
    const imgs = swatchSet.querySelectorAll("img");
    // If there are images, check if all have empty src (or only whitespace)
    if (imgs.length > 0) {
      const allEmpty = Array.from(imgs).every(function (img) {
        return !img.getAttribute("src") || img.getAttribute("src").trim() === "";
      });
      if (allEmpty) {
        swatchSet.classList.add("no-swatches");
      } else {
        swatchSet.classList.remove("no-swatches");
      }
    }
  });
});
